import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import Pending from "../../../../assets/images/pending 2.png";
import Clock from "../../../../assets/images/ClockBG.png";
import Banner from "../../../../assets/images/Rounds/statusTopBanner.png";
import LiN from "../../../../assets/images/Rounds/statusTopBanner.png";
import "./PendingPost.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Slider from "react-slick";
import axios from "axios";
import swal from "sweetalert";
import { Markup } from "interweave";
import noImage from "../../../../assets/images/settings/no-image.png";
import { serverInfo } from "../../../../App";
import { useContext } from "react";
import LoaderPost from "../../../Reuseable/LoaderPost";

const RoundInstructionVideo = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [auditions, setAuditions] = useState([]);
  const [loading, setLoading] = useState(true);

  const instructionVideo = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get(`/api/superstar/audition/pending/roundInstructionVideos`)
        .then((res) => {
          if (res.data.status == 200) {
            setAuditions(res.data.event);
          }
        });
    });
    setLoading(false);
  };
  useEffect(async () => {
    instructionVideo();
  }, []);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          <div className=" row ">
            <div
              title="Live Now"
              className="col-md-2 align-items-center justify-content-center Souvenir-bt "
            >
              <div className="card meetupCard">
                <div className="card-body  align-items-center">
                  <center>
                    <tr>
                      <td className="ad-card-td">
                        <img
                          src={Pending}
                          className="ad-card-img-top"
                          alt="..."
                        />
                      </td>
                      <td className="ad-card-td">
                        <small className="ad-card-small"></small>

                        <small className="ad-card-small">
                          {auditions && auditions.length != 0
                            ? auditions.length
                            : "00"}
                        </small>
                      </td>
                    </tr>
                  </center>
                </div>
                {/* <Link to="/superstar/audition/live"> */}
                <button
                  className="card-footer Souvenir-button  w-100 "
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  {" "}
                  Pending Instruction Video
                </button>
                {/* </Link> */}
              </div>
            </div>
          </div>

          <div className="row liveMeetupBorder my-3 mx-2">
            <div className="d-flex px-4 pt-3">
              <div className="faTrophy">
                <i className="fas fa-trophy"></i>
              </div>
              <h4 className="mx-3 text-white p-2">Pending Instruction Video</h4>
            </div>
            <div className="row my-3">
              {auditions.map((audition, index) => (
                <div className="col-md-3 mb-3" key={index}>
                  <div className="sliderCardBorder">
                    <img
                      src={
                        audition?.image ? imageCdnUrl + audition?.image : noImage
                      }
                      className="img-fluid w-100"
                      alt=""
                      style={{
                        height: "200px",
                        width: "300px",
                      }}
                    />
                    <div className="p-3">
                      <h5 className="text-white text-center">
                        {audition?.audition?.title}
                      </h5>

                      <p className="text-light">
                        <Markup content={audition?.description} />
                      </p>

                      <Link
                        to={`/superstar/auditions/round-instruction-video/${audition.id}`}
                      >
                        <button className="btn btn-done w-100 fw-bold mt-2">
                          Show Invitation
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RoundInstructionVideo;
